import objeler from '../objeler';
import axiosInstance from '../token/axiosInstance';
import buildGridSvg from './svgBuilder';

export function CalcGridCoord(GridSize, e, up) {
    var f = Math.floor(e / GridSize) * GridSize;
    var fark = e - f;
    var x = f;
    if (fark > (GridSize / 2) && up)
        x = f + GridSize;
    return x;
}

export function SetGrid(e) {
    var sz = 7.0865;
    var op = Number(e) + 1;
    const t = e - 5;
    if (t > 0)
        sz = sz * (t + 1);
    if (t < 0)
        sz = sz / ((-t) + 1);
    const grd =
        buildGridSvg(
            (sz * 5),
            (sz * 5),
            "#bbb",
            1,
            "0",
            sz,
            sz,
            "#cbb",
            0.4,
            "0",
            1,
            "unknow",
            "landscape",
            (op / 12)
        );
    return {grd, sz};
}

export function GetNewFileName(filename) {
    filename = "NewDoc";
    var cnt = 0;
    var ind = objeler.userFiles.findIndex(x => x.Name === filename);
    while (ind > -1) {
        cnt++;
        ind = objeler.userFiles.findIndex(x => x.Name === filename + cnt);
    }
    if (cnt == 0) return filename;
    return filename + cnt;
}

export function Clean() {
    objeler.Editor.Clean();
}
export function CleanDirect(filename) {
    objeler.Editor.CleanDirect(filename);
}
export function Save(e) {
    var title = 'Save File';
    if (e)
        title = 'Save and Export File';
    objeler.ModalFileParameters = ({Type: 'Save', Title: title, FileName: objeler.DocName, Pdf: e});
    objeler.openModalFile();
}

export function SaveHtml(e, cshtml) {
    var title = 'Save File';
    if (e)
        title = 'Save and Export File';
    var type = 'SaveHtml'
    if (cshtml)
        type = 'SaveCsHtml'
    objeler.ModalFileParameters = ({
        ...objeler.ModalFileParameters,
        Type: type,
        Title: title,
        FileName: objeler.DocName,
        Pdf: e
    });
    if (objeler.ModalFileParameters.IsNew == 0) {
        objeler.closeModalFile("dosya ismi");
    } else
        objeler.openModalFile();
}

export function SaveForce(e) {
    var title = 'Save File';
    if (e)
        title = 'Save and Export File';
    objeler.ModalFileParameters = ({
        ...objeler.ModalFileParameters,
        Type: 'Save',
        Title: title,
        FileName: objeler.DocName,
        Pdf: e
    });
    if (objeler.ModalFileParameters.IsNew == 0 || isUUID(objeler.DocName)) {
        objeler.closeModalFile("dosya ismi");
    } else
        objeler.openModalFile();
}

export function Datasource() {
    objeler.Editor.openDataDialog();
}

export function Doc() {
    objeler.Editor.openDocDialog();
}

export function Page() {
    objeler.Editor.openPageDialog();
}

export function Clear() {
    objeler.clearDocumentConfirm();
}

export function Open() {
    objeler.Editor.OpenDoc();
}

export function guven() {
    alert(999);
}

export function tarik() {
    alert(777);
}

export function timeout(delay: number) {
    return new Promise(res => setTimeout(res, delay));
}

export function PageSize() {
    return {
        Width: 595.28, Height: 841.19
    }
};

export function GetAlign(e, width, id, content, fontFamily, fontSize, fontWeight, fontStyle) {
    if (e == '1')
        return 'right'
    if (e == '2')
        return 'center'
}

export function GetLetter(cont_width, id, text, align, fontFamily, fontSize, fontWeight, fontStyle) {
    if (align === '3') {
        var nb_char = text.length;
        var spacing = cont_width / nb_char;
        var ltr_spacing = spacing - char_width + (spacing - char_width) / nb_char;
        const st = 'display:none;font-family:' + fontFamily + ';font-size:' + fontSize + 'px;font-weight: ' + (fontWeight ? 'bold' : 'normal') + '; font-style: ' + (fontStyle ? 'italic' : 'normal') + ';'
        var calc = '<span style="' + st + '">' + text + '</span>';
        $('body').append(calc);
        var char_width = $('body').find('span:last').width() / nb_char;
        $('body').find('span:last').remove();
        var ltr_spacing = spacing - char_width + (spacing - char_width) / nb_char;
        return ltr_spacing + 'px';
    } else {
        return null;
    }
};

export function isUUID(str) {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    // console.log('TARRR',uuidRegex.test(str))
    return uuidRegex.test(str);
}

/**
 * Toggles a document's visibility between "private" and "account".
 *
 * Backend enforces: only the doc's owner may change its visibility.
 * Non-owners get a 403/404 — the UI shouldn't render the option for
 * them in the first place, but this is a backstop.
 *
 * After a successful flip, refreshes the document list so the icon
 * updates immediately. Failure surfaces a small alert via objeler.Editor's
 * AlertProvider — same channel the rest of the app uses for toasts.
 *
 * Returns a Promise<boolean> so callers can chain UI feedback if needed.
 */
export async function setVisibility(filename, visibility) {
    if (!filename || (visibility !== 'private' && visibility !== 'account')) {
        console.warn('setVisibility: invalid args', filename, visibility);
        return false;
    }

    try {
        const url =
            window.GET_API_URL(process.env.REACT_APP_SERVICE) +
            '/api/wdc/setvisibility/' + encodeURIComponent(filename) +
            '?visibility=' + visibility;

        const resp = await axiosInstance.post(url);

        if (resp && resp.status >= 200 && resp.status < 300) {
            // Refresh the file list so the lock/team icon flips immediately.
            // GetFiles is exposed on objeler by Container; if for some reason
            // it's not bound, we silently skip — the user will see the new
            // state on next manual refresh.
            if (typeof objeler.GetFiles === 'function') {
                objeler.GetFiles();
            }
            return true;
        }
        return false;
    } catch (err) {
        console.error('setVisibility failed:', err);
        try {
            const {alert} = objeler.Editor.props;
            const msg = err?.response?.status === 403
                ? "You don't have permission to change this document's visibility."
                : "Could not update document visibility. Please try again.";
            alert.error(msg);
        } catch (_) {
            // Alert provider not ready; just log.
        }
        return false;
    }
}